import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import { Layout } from '../components/layout/layout.tsx';
import { ApplicationRoutes } from '../constants/appRoutes';

export const LogoutRouteItem: RouteItem = {
  text: 'Logout',
  layout: <Layout />,
  disableDefaultNavItem: true,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [],
  path: ApplicationRoutes.account.logout,
  async lazy() {
    const component = await import('../features/auth/Logout');
    return { Component: component.Logout };
  }
};

export const AccountManagementItems: RouteItem = {
  path: '/',
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  layout: <Layout />,
  subItems: [
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: ApplicationRoutes.account.resetPassword,
      async lazy() {
        const component = await import('../features/auth/ResetPassword');
        return { Component: component.ResetPasswordPage };
      }
    },
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: ApplicationRoutes.account.requireReset,
      async lazy() {
        const component = await import('../features/auth/PasswordResetRequired.tsx');
        return { Component: component.PasswordResetRequired };
      }
    },
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: ApplicationRoutes.account.forgotPassword,
      async lazy() {
        const component = await import('../features/auth/ForgotPassword');
        return { Component: component.ForgotPasswordPage };
      }
    }
  ]
};

export const MyAccountRouteItem: RouteItem = {
  text: 'My Account',
  layout: <Layout />,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  disableDefaultNavItem: true,
  allowedRoles: [],
  path: ApplicationRoutes.account.myProfile,
  async lazy() {
    const component = await import('../features/auth/MyProfile.tsx');
    return { Component: component.MyProfile };
  }
};

export const LoginRouteItem: RouteItem = {
  path: ApplicationRoutes.account.login,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  text: 'Login',
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/auth/Login');
    return { Component: component.LoginPage };
  }
};
